export default __webpack_public_path__ + "static/garden_design12-299dc5aff9c34dfea043d2f6b1f17dc8.webp";